import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

export interface FloatingMenuData {
  title: string;
  url: string;
  page?: string;
  modal: string;
}

@Component({
  selector: 'fcp-floating-menu',
  templateUrl: './floating-menu.component.html',
  styleUrls: ['./floating-menu.component.scss']
})
export class FloatingMenuComponent {
  @Input() public list: Array<FloatingMenuData>;
  @Output() public clicked: EventEmitter<any> = new EventEmitter();
  public buttonTouggle = true;
  constructor(private router: Router) {}

  public emitClick(modal: string): void {
    this.clicked.emit(modal);
  }

  public changeStateTouggle(): void {
    this.buttonTouggle = !this.buttonTouggle;
  }

  public action(menu) {
    this.changeStateTouggle();
    if (menu.url && !menu.page && !menu.modal) {
      return this.router.navigateByUrl(menu.url);
    }
    if (menu.modal && !menu.page && !menu.url) {
      return this.clicked.emit(menu.modal);
    }
    if (menu.page && !menu.modal && !menu.url) {
      return this.router.navigateByUrl(menu.page);
    }
    return this.clicked.emit(menu.title);
  }
}
